/* eslint-disable jsx-a11y/media-has-caption */
import { AspectRatio } from '@chakra-ui/react';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import type { JunipPhoto, JunipVideo } from 'types/reviews';

interface MediaProps {
  index: number;
  isActive: boolean;
  isVideo: boolean;
  media: JunipPhoto | JunipVideo;
}

export function Media({ index, media, isVideo, isActive }: MediaProps) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (isVideo && isActive) {
      videoRef?.current?.play();
    }
  }, [videoRef, isActive, isVideo]);

  if (isVideo) {
    return (
      <AspectRatio
        height="100%"
        width="100%"
        sx={{
          video: {
            objectFit: 'cover',
          },
        }}
      >
        <video
          ref={videoRef}
          width="100%"
          height="100%"
          controls
          aria-label={`User review video #${index + 1}`}
        >
          <source src={(media as JunipVideo).original} type="video/mp4" />
        </video>
      </AspectRatio>
    );
  }

  if (typeof (media as JunipPhoto)?.large === 'string') {
    return (
      <Image
        key={media.thumbnail}
        alt={`User photo #${index + 1}`}
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        src={(media as JunipPhoto).large as string}
        fill
        sizes="100vw"
        style={{
          objectFit: 'contain',
        }}
      />
    );
  }

  return null;
}
